import { render, staticRenderFns } from "./batchReceive.vue?vue&type=template&id=8229bca8&scoped=true&"
import script from "./batchReceive.vue?vue&type=script&lang=js&"
export * from "./batchReceive.vue?vue&type=script&lang=js&"
import style0 from "./batchReceive.vue?vue&type=style&index=0&id=8229bca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229bca8",
  null
  
)

export default component.exports